var CellType;
(function (CellType) {
    CellType[CellType["BOMB"] = -1] = "BOMB";
    CellType[CellType["EMPTY"] = 0] = "EMPTY";
})(CellType || (CellType = {}));
export default CellType;
